import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { WebIndex } from "./view/2023/WebIndex";
import { WebIndex2024 } from "./view/2024/WebIndex";
import { MobileIndex } from "./view/2023/MobileIndex";
import { MobileIndex2024 } from "./view/2024/MobileIndex";
import { WebAlgo } from "./view/2023/WebAlgo/index";
import { WebAlgo2024 } from "./view/2024/WebAlgo/index";
import { WebRobot } from "./view/2023/WebRobot/index";
import { MobileAlgo } from "./view/2023/MobileAlgo/index";
import { MobileAlgo2024 } from "./view/2024/MobileAlgo/index";
import { MobileRobot } from "./view/2023/MobileRobot/index";
import { WebRobot2024 } from "./view/2024/WebRobot/index";
import { MobileRobot2024 } from "./view/2024/MobileRobot/index";

const Home = () => {
  const isMobileVal = window.matchMedia(
    "only screen and (max-width: 480px)"
  ).matches;
  const [isMobile, setIsMobile] = useState(isMobileVal);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.matchMedia("only screen and (max-width: 480px)").matches);
    }

    window.addEventListener('resize', handleResize);

    return (() => {
      window.removeEventListener('resize', handleResize);
    })

  }, [])

  const RenderEmpty = () => {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '100%', paddingTop: 160 }}>
        <div>欢迎使用</div>
      </div>
    )
  }

  return (
    <Router>
      <Routes>
        <Route path="*" element={<Navigate to="/2024" replace />} />
        <Route path="/2024" element={isMobile ? <MobileIndex2024 /> : <WebIndex2024 />} />
        <Route path="/ai2024" element={isMobile ? <MobileAlgo2024 /> : <WebAlgo2024 />} />
        <Route path="/robot2024" element={isMobile ? <MobileRobot2024 /> : <WebRobot2024 />} />
        <Route path="/2023" element={isMobile ? <MobileIndex /> : <WebIndex />} />
        <Route
          path="/ai2023"
          element={isMobile ? <MobileAlgo /> : <WebAlgo />}
        />
        <Route
          path="/robot2023"
          element={isMobile ? <MobileRobot /> : <WebRobot />}
        />
      </Routes>
    </Router>
  );
};

function App() {
  return (
    <>
      <Home />
    </>
  );
}

export default App;
